import { getFragmentData } from '@/__generated__';
import { GateMovementHistoryFragmentFragment } from '@/__generated__/graphql';
import { GATE_MOVEMENT_HISTORY_FRAGMENT } from '../graphql/fragments/gateMovementHistoryFragment';

export const getMovementHistoryFragmentData = (movementFragment: {
  ' $fragmentRefs'?: {
    GateMovementHistoryFragmentFragment: GateMovementHistoryFragmentFragment;
  };
}) => {
  return getFragmentData(GATE_MOVEMENT_HISTORY_FRAGMENT, movementFragment);
};
